/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCountryState,
    IdentityMelcoModelsCountryStateFromJSON,
    IdentityMelcoModelsCountryStateFromJSONTyped,
    IdentityMelcoModelsCountryStateToJSON,
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsCountryState
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsCountryState {
    /**
     * 
     * @type {Array<IdentityMelcoModelsCountryState>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCountryState
     */
    list: Array<IdentityMelcoModelsCountryState>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCountryState
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsCountryState
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsCountryStateFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsCountryState {
    return IdentityMelcoModelsGenericList1MelcoModelsCountryStateFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsCountryStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsCountryState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsCountryStateFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsCountryStateToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsCountryState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsCountryStateToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


